// extracted by mini-css-extract-plugin
export default {"container":"CreateMessageForm_container__dzBDT","image_preview":"CreateMessageForm_image_preview__KDfes"};